import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { Container } from "../Grid/Grid";
import { Svg, SVG_ICONS } from "../__common/Svg/Svg";
import { Typography } from "../__common/Typography/Typography";
import "./HelpTipsPopup.scss";
import { useCookie } from "../../hooks/cookie-hooks";
import { ROUTES } from "../../configs/routes";
import { INVALID_PAGE } from "../../constants/storage";
import ClickableElement from "../__common/_controls/Button/ClickableElement";

export const HelpTipsPopup = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { isShowNotice, setShowNotice, setCookieShowNotice } = useCookie();

  const handleOnHideClick = useCallback(() => {
    setShowNotice(false);
    setCookieShowNotice();
  }, [setShowNotice, setCookieShowNotice]);

  const isPageInvalid = sessionStorage.getItem(INVALID_PAGE) === "true";

  // Early return: don't render if notice is dismissed or page is invalid
  if (!isShowNotice || isPageInvalid) {
    return null;
  }

  return (
    <Container>
      <div
        data-testid="help-tips-popup"
        className={classNames("helptips__container", {
          home: pathname === ROUTES.ROOT,
        })}
        id="helptipsPopup"
      >
        <Typography
          variant="body1"
          component="span"
          className="helptips__container__info"
          weight="w700"
        >
          {t("PRIVACY_HELPTIPS_TEXT")}
        </Typography>

        <div className="helptips-close-container">
          <ClickableElement
            className="helptips__container__ok"
            onClick={handleOnHideClick}
            testId="help-tips-on-hide-button"
          >
            <Typography variant="body2" component="span" weight="w700">
              {t("PRIVACY_HELPTIPS_BTN")}
            </Typography>
          </ClickableElement>

          <button
            className="helptips__container__close"
            onClick={handleOnHideClick}
            tabIndex={-1}
            aria-label={t("PRIVACY_COMMON_CLOSE_ALT_TEXT")}
          >
            <Svg
              icon={SVG_ICONS.DRAWER_CLOSE}
              width={16}
              height={16}
              title={t("PRIVACY_COMMON_CLOSE_ALT_TEXT")}
            />
          </button>
        </div>
      </div>
    </Container>
  );
};
